import { Host, h } from "@stencil/core";
import { toFormField } from "../../utils/FormDefinition";
export class ApieFormDefinition {
    constructor() {
        this.prototyped = false;
        this.status = 'idle';
    }
    async getDefinition() {
        this.status = 'building';
        const fields = await toFormField(this.el.childNodes);
        this.status = 'built';
        return Promise.resolve({ fields });
    }
    render() {
        return (h(Host, { key: '4dc9b6c1b58fd35d1e9a3024677ba8b9c3d02cbc' }, h("slot", { key: 'bb513570a3a93a31fb3e401c4e8b73e1abf0789a' })));
    }
    static get is() { return "apie-form-definition"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-form-definition.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-form-definition.css"]
        };
    }
    static get properties() {
        return {
            "prototyped": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "prototyped",
                "reflect": true,
                "defaultValue": "false"
            },
            "status": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "status",
                "reflect": true,
                "defaultValue": "'idle'"
            }
        };
    }
    static get methods() {
        return {
            "getDefinition": {
                "complexType": {
                    "signature": "() => Promise<FormDefinition>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "FormDefinition": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::FormDefinition"
                        },
                        "FormField": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::FormField"
                        }
                    },
                    "return": "Promise<FormDefinition>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=apie-form-definition.js.map
